module.exports = __webpack_public_path__ + "media/assets/community/facebook-logo-bbb9bc4556a3abcc4fc73b36bd92af4af3d97c35cdc1601b0c5fd40fe0b033bc.png";